export function getScoutTemplateMetricCount(template) {
  const stats = Array.isArray(template?.selectedStats)
    ? template.selectedStats
    : [];
  const biometrics = Array.isArray(template?.selectedBiometrics)
    ? template.selectedBiometrics
    : [];
  let count = 1; // positions are always counted as one filter and cant be omitted

  // Only decrement count for 'plays' metric with value 0
  const playsMetric = stats.find((m) => m.key === 'plays');
  if (playsMetric && playsMetric.value === 0) {
    count -= 1;
  }

  const hasNcaaTransferPortal = biometrics.find(
    (b) => b.key === 'ncaaTransferPortal',
  )?.value;
  if (hasNcaaTransferPortal) {
    count += 1;
  }

  if (template?.showFavourites) {
    count += 1;
  }

  // ensure that only stats after the first are counted
  count += stats.length;

  // ensure that only biometrics other than ncaaTransferPortal are counted
  const biometricFiltered = biometrics.filter(
    (b) => b.key !== 'ncaaTransferPortal',
  );

  count += biometricFiltered.length;

  return count;
}
